import React from 'react';
import PropTypes from 'prop-types';
import { Visible, Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { DetailRow } from 'src/components';
import {
  REMAINDER_TREATMENT,
  REMAINDER_PLATE_TYPE,
  REMAINDER_CHECKED,
  REMAINDER_VOLUME,
  REMAINDER_PLATE_TYPE_OPTIONS,
  SECOND_PRIORITY_COUNTRIES
} from 'src/constants/forms';
import { toDecimalValue, getCountryCode } from 'src/utils';

import messages from 'src/messages';

const RemaindersDetailsComponent = ({ details = {}, visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <>
      <DetailRow
        label={messages.remainders}
        value={(
          <Message message={details[REMAINDER_CHECKED]?.value ?
            messages.yes :
            messages.no}
          />
        )}
        dots
      />
      <Spacer bottom={8} />
      <Visible when={details[REMAINDER_CHECKED]?.value}>
        <DetailRow
          label={messages.remainderTreatment}
          value={details[REMAINDER_TREATMENT]?.value}
          dots
          inline
        />
        <Spacer bottom={8} />
        <DetailRow
          label={messages.remainderPlateType}
          value={
            REMAINDER_PLATE_TYPE_OPTIONS.find(
              (item) => item.value === details[REMAINDER_PLATE_TYPE]?.value
            )?.label
          }
          dots
          inline
        />
        <Spacer bottom={8} />
        <Visible when={!SECOND_PRIORITY_COUNTRIES.includes(getCountryCode())}>
          <DetailRow
            label={messages.volume}
            value={toDecimalValue(details[REMAINDER_VOLUME]?.value)}
            dots
            inline
          />
          <Spacer bottom={8} />
        </Visible>
      </Visible>
    </>
  );
};

RemaindersDetailsComponent.propTypes = {
  details: PropTypes.object,
  visible: PropTypes.bool,
};

export default RemaindersDetailsComponent;
